import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import autobind from 'autobind-decorator';

export default class FileMessage extends Component {
  static propTypes = {
    fileName: PropTypes.string.isRequired,
    onDownload: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      downloading: false
    };
  }

  @autobind
  download() {
    this.setState({ downloading: true });
    this.props.onDownload().finally(() => this.setState({ downloading: false }));
  }

  render() {
    const { fileName } = this.props;
    const { downloading } = this.state;

    return (
      <div className="file-message-wraper">
        <B.Button disabled={downloading} bsStyle="primary" className="file-message-btn">
          <B.Glyphicon glyph="download-alt" className="file-message-glyph" onClick={this.download} />
        </B.Button>
        <span className="file-message-filename">El agente envió un archivo: {fileName}</span>
        {downloading ? <B.ProgressBar className="file-message-progress" now={100} striped bsStyle="primary" /> : undefined}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/chat/fileUpload/FileMessage.js